import * as React from "react"
import ReduxWrapper from "./src/state/reduxwrapper"

import { outboundLinkClicked } from "./src/segment"
import { getPageViewProps } from "./src/components/vendor/Analytics/pageViewPropsSnippet"
import { getBlogPageClassification } from "./src/components/vendor/Analytics/blogPageClassification"
import { SEGMENT_ANONYMOUS_ID_COOKIE } from "./src/constants/cookies"
import "./src/utils/global.css"

export const wrapRootElement = ({ element }) => (
  <ReduxWrapper>{element}</ReduxWrapper>
)

export const onClientEntry = async () => {
  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`)
  }
}

export function onRouteUpdate({ location, prevLocation }) {
  // NT2-29911: Segment page view; props shared with the head GA4 page_view.
  const pageTracker = () => {
    if (!window.analytics || typeof window.analytics.page !== "function") {
      return
    }
    const name = document.title.split(" | ")[0]

    // Use prevLocation if internal, fallback to document.referrer for external entry
    const page_referrer = prevLocation
      ? window.location.origin + prevLocation.pathname
      : document.referrer

    window.analytics.page(name, {
      ...getPageViewProps(location.pathname, page_referrer),
      ...getBlogPageClassification(location.pathname),
      segment_anonymous_id: readCookie(SEGMENT_ANONYMOUS_ID_COOKIE) || null,
      path: location.pathname,
      url: location.href,
      userAgent: navigator.userAgent,
      title: name,
    })
  }

  // Delay so document.title is the new page's title
  setTimeout(pageTracker, 250)
}

const readCookie = (name) => {
  const eq = name + "="
  const ca = document.cookie.split(";")
  for (let j = 0; j < ca.length; j++) {
    let c = ca[j]
    while (c.charAt(0) === " ") c = c.substring(1, c.length)
    if (c.indexOf(eq) === 0) {
      return decodeURIComponent(c.substring(eq.length, c.length))
    }
  }
  return null
}

export const onInitialClientRender = () => {
  window.onbeforeunload = function (e) {
    if (
      document.activeElement &&
      document.activeElement.href &&
      !document.activeElement.href.includes("nutrafol")
    ) {
      return outboundLinkClicked(
        document.activeElement.href,
        e.path[0].location.href,
        document.activeElement.innerText,
        "link"
      )
    }
  }

  const addSegmentMiddleware = (num) => {
    if (window.analytics) {
      const addUserAgentDataToTrack = ({ payload, next }) => {
        if (!!payload && !!payload.obj && !!payload.obj.properties) {
          payload.obj.properties.userAgent = navigator.userAgent
        }
        next(payload)
      }
      window.analytics.addSourceMiddleware(addUserAgentDataToTrack)
    } else {
      if (num < 10) {
        setTimeout(
          () => {
            let newNum = num + 1
            addSegmentMiddleware(newNum)
          },
          500,
          num
        )
      }
    }
  }

  setTimeout(() => {
    addSegmentMiddleware(0)
  }, 1000)
}
